export const Footer = () => {
    return (
      <footer className="footer">
        <div>
          <ul className="list-none flex-row flex-center">
            <li>
              <i className="fa fa-github"></i>Github
            </li>
            <li>
              <i class="fa fa-twitter-square" aria-hidden="true"></i>Twitter
            </li>
            <li>
              <i class="fa fa-linkedin-square" aria-hidden="true"></i>linkedIn
            </li>
          </ul>
        </div>
      </footer>
    );
  };